import IdentityPage from './identityPage';
export default IdentityPage;
